import { useEffect, useState } from "react";
import RealtimeWaitingTime from "./RealtimeWaitingTime";

const SmartWaitingBadge = ({ waitingSince, longWaitThreshold, timeHeight }) => {
  // This state forces a re-render every minute to check the time
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000); // Check every 60 seconds
    return () => clearInterval(interval);
  }, []);

  const diffInMinutes = (now - waitingSince) / 1000 / 60;
  const isLongWait = diffInMinutes >= longWaitThreshold;
  // console.log(longWaitThreshold)
  return (
    <div
      className={`mt-1 py-0 px-2 rounded-pill d-inline-flex align-items-center justify-content-center gap-1 transition-all ${isLongWait ? 'bg-danger-subtle animate-pulse border border-danger' : 'border'
        }`}
      style={{
        minWidth: '65px', // Reduced width
        height: timeHeight || '22px',   // Fixed height for consistency
        fontSize: '0.7rem' // Smaller font
      }}
    >
      <i
        className={`bi ${isLongWait ? 'bi-exclamation-triangle-fill text-danger' : 'bi-clock text-muted'}`}
        style={{ fontSize: '0.65rem' }} // Tiny icon
      ></i>
      <span className={`fw-bold ${isLongWait ? 'text-danger' : null}`} style={{ letterSpacing: '-0.2px' }}>
        <RealtimeWaitingTime waitingSince={waitingSince} />
      </span>
    </div>
  );
};

export default SmartWaitingBadge;